import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons/faCircleArrowLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
const estiloAcompanhamento = require("./acompanhamento.module.scss").default;
import globalMU from "../../../globalMU";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";

export type DadosAcompanhamentos = {
  Oid: number;
  Data: string;
  Observacao: string;
  TipoAcompanhamento: string;
  NomeUsuario: string;
  UserMessage: string;
};

export type AcompanhamentoProps = {
  cpfcnpj: string;
  nome: string;
  dadosAcompanhamentos: DadosAcompanhamentos[];
  ActualPage: number
  PageCount: number;
  onAlterarListaSelecionada: (numeroPagina: number) => void;
};

export const Acompanhamento = (props: AcompanhamentoProps) => {
  return (
    <div>
      <br />
      {props.dadosAcompanhamentos != undefined &&

        <>
          <div className={estiloAcompanhamento.InformacoesClienteAcompanhamento}>
            <div className={estiloAcompanhamento.primeiraColuna}>CPF/CNPJ</div>
            <div>{props.cpfcnpj}</div>
            <div className={estiloAcompanhamento.primeiraColuna}>Nome</div>
            <div>{props.nome}</div>
          </div>
          <br />
          <div>
            <div
              className={`_table _w-full _border-collapse ${estiloAcompanhamento.tabelaAcompanhamentos}`}
            >
              <div className="_table-header-group ">
                <div className="_table-row">
                  <div
                    className={`_table-cell _font-bold ${estiloAcompanhamento.tableCellHeader}`}
                  >
                    Data
                  </div>
                  <div
                    className={`_table-cell _font-bold ${estiloAcompanhamento.tableCellHeader}`}
                  >
                    Usuário
                  </div>
                  <div
                    className={`_table-cell _font-bold ${estiloAcompanhamento.tableCellHeader}`}
                  >
                    Observação
                  </div>
                </div>
              </div>
              <div className="_table-row-group">
                {props.dadosAcompanhamentos.map((value) => (
                  <div key={value.Oid} className="_table-row ">
                    <div
                      className={`_table-cell ${estiloAcompanhamento.tableCellBody}`}
                    >
                      {globalMU.formatDate(value.Data)}
                    </div>
                    <div
                      className={`_table-cell ${estiloAcompanhamento.tableCellBody}`}
                    >
                      {value.NomeUsuario}
                    </div>
                    <div
                      className={`_table-cell ${estiloAcompanhamento.tableCellBody}`}
                    >
                      {value.Observacao}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {props.PageCount > 1 && (
            <div style={{ marginTop: "0.5em" }}>
              <Paginacao
                paginaAtual={props.ActualPage}
                totalPaginas={props.PageCount}
                id="Acompanhamento_Paginacao"
                onAlterarListaSelecionada={props.onAlterarListaSelecionada}
              />
            </div>
          )}
          </div>
          {<section style={{ marginBottom: "100px" }} />}
        </>
      }
    </div>
  );
};
